import React from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector,useDispatch } from 'react-redux'
import {addItemsTabWarnings,deleteItemsTabWarnings} from "../../actions/errorValidationActions";
import { validation } from '../../util/cdsFieldPatterns';


const Procedure = ({ 
  isFormDisabled,
  updateData,
  saveData,
  merchandiseId, 
  invoiceId,
  lineNumber,
  isImportShipment,
  invoiceItemIndex,
  fieldPattern,
  validateError
}) =>{
  const procedureList = useSelector((state) => state.DropDownValues.procedure) 
  const procedures=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.procedures)
  const proceduresErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_procedures`]) 
  
  const { declarationCat = '' } = useSelector((state) => state.Shipment) || []
  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'itemsTab'),
    [declarationCat]
  )

  const dispatch=useDispatch()


  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }

  return (
       <Grid.Row>
       <Grid.Column width={16} className='divFormFeild border-bottom b-blr-5 b-brr-5'>
        <DropDown
          id={`procedure-${invoiceId}-${merchandiseId}`}
          label='Procedure'
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          boxNumber='1/10'
          labelClass='text-none'
          isLabel={true}
          mandatory={false}
          data={procedureList}
          value={procedures}
          errors={isImportShipment ? 
            getValidationError("procedures",procedures,true) :
            proceduresErr && proceduresErr?.msg}
          clearable
          onChange={(value) => {
            updateData({procedures:value?.trim()})
            saveData({procedures:value})
            
            const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_procedures`
            validateError(
              { [key]: '' },
              { [key]: value },
              { [key]: fieldPattern().items?.lineItem(invoiceItemIndex + 1, lineNumber)?.procedures }
            )
            
            let err = getValidationError('procedures', value, 'itemsTab',true)
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `procedures-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `procedures-${merchandiseId}`)
          }}
          
        />
       
      </Grid.Column> 
      </Grid.Row>
     
  )
}

export default React.memo(Procedure)


